import { graphql } from '@shared/api/gql';

export const assetsQueryDocument = graphql(`
	query GetAssets {
		fonts {
			name
			urls
		}
	}
`);
